import { useToast } from '@chakra-ui/react';
import SettlementProcParamDataTableRowFormUI from '@Modules/admin/integrationSettings/components/forms/base/SettlementProcParamDataTableRowFormUI';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import settlementProcParamDataTableRowFormMeta from '../../../forms/base/settlementProcessingParameter/settlementProcParamDataTableRowFormMeta';
import { getSettlementProcessingParametersDataTableColumns, TSettlementProcParamDataTableData } from './SettlementProcessingParametersDataTableMeta';
import settlementProcParamFakeData from './SettlementProcParamFakeData';

const SettlementProcessingParametersDataTableHandler = () => {
  const [rowDataTable, setRowDataTable] =
    React.useState<TSettlementProcParamDataTableData>({
        primaryKey: '',
        tc: "",
        usage: "",
        proc: "",
        entity1: "",
        entity2: "",
        entity3: "",
    });

  const editModalRef = React.useRef<any>(null);

  const formModalRef = React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
  }>(null);

  const toast = useToast();

  //   Initialize react Query to GET Data
  const queryKey = ['SettlementProcessingParameters'];
  const { data, isLoading } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
      // TODO: Replace this by your fetcher function
      return new Promise(function (resolve) {
        setTimeout(() => resolve(settlementProcParamFakeData), 500);
      });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  const { isLoading: isSubmitting } = useMutation(async () => {}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title:
          "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
            await mutateAsync();
        } catch (error) {
            console.log(error);
        }*/
  };

  const handleEdit = (row: any) => {
    setRowDataTable(row.original);

    editModalRef?.current?.onOpen();
  };

  const columns = getSettlementProcessingParametersDataTableColumns({
    isLoading,
    handleEdit,
  });

  const triggerSubmit = () => {
    formModalRef?.current?.submitBtnRef?.current?.click();
  };

  const onModalFormSubmit = async (payload: any) => {
    console.log('Modal payload: ', payload);
  };

  return (
    <>
      <CustomReactTable
        data={data || settlementProcParamFakeData.slice(0, 4)}
        columns={columns}
      />

      <CustomAppModal
        title="Editer"
        ref={editModalRef}
        actionBtn={
          <CustomSaveBtn
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            onClick={triggerSubmit}
          />
        }
        actionBtnText={'Valider'}
        size="3xl"
        isCentered
        closeOnOverlayClick={false}
      >
        <SettlementProcParamDataTableRowFormUI
          data={rowDataTable}
          meta={settlementProcParamDataTableRowFormMeta}
          onSubmit={onModalFormSubmit}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
          ref={formModalRef}
        />
      </CustomAppModal>
    </>
  );
};

export default SettlementProcessingParametersDataTableHandler;
